import { SelectedMenu } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';
import deleteProduct from 'rangeConfig/shared/behaviors/deleteProduct';
import {
  matchSelectedOrganizersWidth,
  matchOrganizerDepth,
  matchOrganizerType
} from 'rangeConfig/pax/filters/selectedMenuProductFilters';
import replaceOrganizer from 'rangeConfig/pax/behaviors/replaceOrganizer';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.productListAccessoriesTitle',
  behaviors: {
    productDeleted: [deleteProduct]
  },
  content: [
    {
      id: 'accessories-selected-menu-accessories',
      title: '',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText, communicatedSizeText',
      behaviors: {
        productClicked: [replaceOrganizer],
        productDropped: [replaceOrganizer]
      },
      productTypes: [
        ProductType.PAX_DRAWER_MAT,
        ProductType.PAX_DRAWER_BOX_ASM,
        ProductType.PAX_SKUBB_STORAGE_CASES,
        ProductType.PAX_SKUBB_SHOE_BOXES,
        ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
        ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
        ProductType.PAX_SKUBB_STORAGE_BOXES,
        ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
        ProductType.PAX_SKUBB_HANGING_STORAGE,
        ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
        ProductType.PAX_SKUBB_STORAGE_CASE_WRAP,
        ProductType.PAX_SHOE_MAT
      ],
      productFilters: [matchSelectedOrganizersWidth, matchOrganizerDepth, matchOrganizerType]
    }
  ]
};

export default selectedMenu;
